import { createModule } from '../createModule';

export const role = createModule('role');